/**
 * @file This file sets up the Redux store for the asset schema module.
 * It configures the store with the root reducer and middleware, including saga middleware.
 */

import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { assetSchemaRootReducer } from '../reducers';
import { assetSchemaRootSaga } from '../sagas';

const sagaMiddleware = createSagaMiddleware();

/**
 * The configured Redux store for the asset schema module.
 */
export const assetSchemaStore = configureStore({
	reducer: assetSchemaRootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat(sagaMiddleware),
});

/**
 * Runs the root saga for the asset schema module.
 */
sagaMiddleware.run(assetSchemaRootSaga);

/**
 * Type representing the root state of the asset schema store.
 */
export type AssetSchemaRootState = ReturnType<typeof assetSchemaStore.getState>;
